import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PhoneService } from '../services';
import { PhoneList, Brand, Variant } from '../models';

@Component({
  selector: 'app-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss']
})
export class BrandListComponent implements OnInit, OnDestroy {
  private sub;
  phoneList: PhoneList;
  brand: Brand;
  variants: Variant[] = [];
  brandId: string;

  constructor(private route: ActivatedRoute, private phoneService: PhoneService) { }

  ngOnInit() {
    this.sub = this.route.params
      .switchMap(routeParams => {
          this.brandId = routeParams['brandId'];
          return this.phoneService.obs.phoneList;
        })
      .subscribe((phoneList: PhoneList) => {
        this.brand = phoneList.brands.get(this.brandId);
        if (this.brand) {
          const phones = this.brand.phones;
          phones.forEach(phone => {
            let variants = Array.from(phone.variants.values());
            this.variants.push(...<Array<Variant>>variants);
          });
          console.log(this.variants);
        }
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/brand-list/brand-list.component.ts